import React, { FC, useEffect, useState } from 'react';
import { View } from 'react-native';

import { ActualTotalWithProgressIndicatorProps } from '@v2/context/ProductionBatch/types';
import { scale } from '@components/frame';
import { SmallLoading } from '@components/loading';
import { useSetInterval } from '@v2/pages/common/hooks/useSetInterval';
import ProgressIndicator from './ProgressIndicator';
import TimeDisplay from '@components/common/TimeDisplay';
import { getOffsetInSeconds, getInitialActualTotal, getInitialScheduledTime, calculateProgress, getShouldNotRunTime } from '@v2/context/ProductionBatch/tile/helpers';

const ActualTotalWithProgressIndicator: FC<ActualTotalWithProgressIndicatorProps> = ({
  C,
  batch,
  offset = 0,
  statistics,
  withHMSFormat = true,
  fontForDigit = 'Time 1',
  fontForSecondDigit = 'Time 3',
}) => {
  const offsetInSeconds = getOffsetInSeconds(offset);
  const initialActualTotal = getInitialActualTotal(batch, statistics, 0);
  const [actualTotal, setActualTotal] = useState<number | undefined>(initialActualTotal != null ? initialActualTotal + offsetInSeconds : undefined);

  const initialScheduledTime = getInitialScheduledTime(batch, statistics);

  const progress = calculateProgress(actualTotal, initialScheduledTime);

  useEffect(() => {
    if (initialActualTotal != null) {
      setActualTotal(initialActualTotal + offsetInSeconds);
    }
  }, [initialActualTotal, offsetInSeconds]);

  const shouldNotRunTime = getShouldNotRunTime(batch.isInProgress, actualTotal);

  useSetInterval({
    disabled: shouldNotRunTime,
    action: () => setActualTotal((prev) => prev + 1),
    dependencyArray: [shouldNotRunTime],
  });

  return (
    <View style={[{ flexDirection: 'row', alignItems: 'center', gap: scale(5), marginTop: scale(-3), height: scale(26) }]}>
      {actualTotal == null || progress == null ? (
        <SmallLoading />
      ) : (
        <>
          <ProgressIndicator C={C} progress={progress} />
          <TimeDisplay
            withHMSFormat={withHMSFormat}
            value={actualTotal}
            C={C}
            fontForDigit={fontForDigit}
            fontForSecondLetter="Caption 2"
            fontForSecondDigit={fontForSecondDigit}
          />
        </>
      )}
    </View>
  );
};

export default ActualTotalWithProgressIndicator;